import { render, staticRenderFns } from "./CoLockedContent.vue?vue&type=template&id=345c1cea&scoped=true&"
import script from "./CoLockedContent.vue?vue&type=script&lang=ts&"
export * from "./CoLockedContent.vue?vue&type=script&lang=ts&"
import style0 from "./CoLockedContent.vue?vue&type=style&index=0&id=345c1cea&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "345c1cea",
  null
  
)

export default component.exports